<template>
	<div class="card" :class="{'card--loading':loading}">
		<div class="card__loader" v-if="loading">
			<LoadingSpinner />
		</div>
		<div class="card__header" v-if="$slots.header">
			<slot name="header" />
		</div>
		<div class="card__body">
			<slot />
		</div>
	</div>
</template>

<script setup>
import LoadingSpinner from '@/components/LoadingSpinner.vue'

const props = defineProps({
	loading: Boolean,
})
</script>

<style scoped lang="scss">

.card {
	$card: &;
	background-color: var(--color--background);
	border: 1px solid var(--color--background-light);
	border-radius: 5px;
	// box-shadow: 0 0 0 1px rgba(63,63,68,.05),0 1px 3px 0 rgba(63,63,68,.15);
	padding: 1rem;
	position: relative;

	&:after {
		content: '';
		position: absolute;
		bottom: -3px;
		left: 3px;
		right: 3px;
		height: 3px;
		background: linear-gradient(
			to bottom,
			rgba(0,0,0,0.05),
			transparent
		);
	}

	// box-shadow: 0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15);
	// border-radius: modules.$border-radius;

	:deep(.card__title) {
		font-weight: 450;
		margin: 0;
		text-transform: uppercase;

	}

	:deep(.card__subtitle) {
		// @include modules.gutter('margin-left');
		// @include modules.gutter('margin-bottom', 0.5);
		// @include modules.gutter('margin-top', 0);
		// @include modules.gutter('padding', 0);
		font-size: 14px;
		font-weight: 400;
	}

	:deep(.card__fields) {
		// @include modules.gutter('margin');
		// border-top: 1px solid modules.color_('border');
	}

	// :deep(.card__item) {
	// 	// @include modules.gutter('padding', 0.5);
	// 	// @include gutter('padding-left');
	// 	// @include gutter('padding-right');
	// 	align-items: center;
	// 	// border-bottom: 1px solid modules.color_('border');
	// 	// color: modules.color_('text');
	// 	display: flex;
	// 	justify-content: space-between;
	// 	// transition: background-color 150ms modules.$ease-standard;

	// 	a:not(.mdc-button) {
	// 		// color: modules.color_('text');
	// 		text-decoration: none;
	// 	}

	// 	&-actions {
	// 		opacity: 0;
	// 		// transition: opacity 150ms modules.$ease-standard;
	// 	}

	// 	&--no-hover {
	// 		#{$card}__item-actions {
	// 			opacity: 1;
	// 		}
	// 	}

	// 	&:not(#{$card}__item--no-hover) {
	// 		&:hover {
	// 			// background-color: modules.color_('background', 'open');

	// 			#{$card}__item-actions {
	// 				opacity: 1;
	// 			}
	// 		}
	// 	}

	// 	&-label {
	// 		// color: modules.color_('text');
	// 		font-weight: 600;
	// 	}
	// }

	:deep(.card__loader) {
		align-items: center;
		// background-color: rgba(225, 225, 225, 0.15);
		border-radius: var(--border-radius);
		backdrop-filter: blur(1px);
		// border-radius: modules.$border-radius;
		display: flex;
		justify-content: center;
		position: absolute;
		bottom: 0;
		left: 0;
		height: calc(100% - 70px);
		width: 100%;
		z-index: 2;
	}

	:deep(.card__header) {
		border-bottom: 1px solid var(--color--border);
		padding: 0 0 0.5rem;
		margin-bottom: 1rem;
		min-height: 45px;
		// @include modules.gutter('padding');
		// border-bottom: 1px solid modules.color_('border', 'light');

		align-items: center;
		display: flex;
		justify-content: space-between;
	}

	&__actions {
		display: flex;
	}

	&__title {
		// @include modules.fontSize(20px);
		line-height: 1;
		margin: 0;
	}

	:deep(.card__subtitle) {
		// @include modules.fontSize(16px);
		font-weight: 400;
		line-height: 1;
		margin: 0;
	}
}
</style>
